module.exports = {
  route_1: {
    'mon-sat': {
      'northbound': 'trip_1n_0730_nov21', //1N Berwick via Somersworth - Sixth Street
      'southbound': 'trip_1s_0555_nov21', //1S Dover via Sixth Street
    }
  },

  route_6: {
    'mon-fri': {
      'northbound': 'trip_6n_0600_nov21', //6N Farmington'
      'southbound': 'trip_6s_0525_nov21', //6S Rochester
    },
  },

  route_12: {
    'mon-sat': {
      'northbound': 'trip_12n_0630_nov21', //12N Rochester via 108
      'southbound': 'trip_12s_0654_nov21', //12S Dover via 108
    }
  },

  route_13: {
    'mon-sat': {
      'northbound': 'trip_13n_0700_nov21', //13N Downtown Dover - Continues to Rochester via 108
      'southbound': 'trip_13s_0530_nov21', //13S Downtown Portsmouth
    }
  },

  route_14: {
    'mon-sat': {
      'northbound': 'trip_14n_0741_nov21', //14N Downtown Rochester via Washington Street
      'southbound': 'trip_14s_0700_nov21', //14S Rochester Park & Ride
    }
  },

  //INBOUND OUTBOUND TRIPS
  route_33: {
    'mon-fri': {
      'inbound': 'trip_33i_0659_nov21', //33 Downtown Dover via Whittier - Shaws
      'outbound': 'trip_33o_0630_nov21', //33 County Complex via Whittier - Shaws
    },
    'saturday': {
      'inbound': 'trip_33i_s_1257_jan23', //33 Downtown Dover via Whittier - Shaws
      'outbound': 'trip_33o_s_1230_jan23', //33 Portland Avenue via Whittier - Shaws
    },
  },

  route_34: {
    'mon-sat': {
      'inbound': 'trip_34i_0517_nov21', //34 Downtown Dover
      'outbound': 'trip_34o_0830_nov21', //34 Knox Marsh Road / 155 Outbound
    }
  },

  route_40: {
    'mon-sat': {
      'inbound': 'trip_40i_0724_nov21', //40 Downtown Portsmouth via Borthwick - Islington
      'outbound': 'trip_40o_0700_nov21', //40 Borthwick Trolley Outbound via Islington
    }
  },

  route_41: {
    'mon-sat': {
      'inbound': 'trip_41i_0630_nov21', //41 Downtown Portsmouth
      'outbound': 'trip_41o_0600_nov21', //41 Lafayette Trolley Outbound
    }
  },

  route_42: {
    'mon-fri': {
      'inbound': 'trip_42i_0643_nov21', //42 Downtown Portsmouth via portsmouth Transportation Center
      'outbound': 'trip_42o_0622_nov21', //42 Pease Shuttle Outbound via Portsmouth Transportation Center
    }
  },

  route_43: {
    'mon-sat': {
      'inbound': 'trip_43i_0833_nov21', //43 Downtown Portsmouth via Woodbury
      'outbound': 'trip_43o_0800_nov21', //43 Newington via Woodbury Outbound
    }
  },

  route_44: {
    'mon-fri': {
      'inbound': 'trip_44i_0747_nov21', //44 Downtown Portsmouthd
      'outbound': 'trip_44o_0736_nov21', //44 Kittery PNSY Gate 1 via City Hall Outbound
    }
  },

  route_100_20: {
    'mon-fri': {
      'pm': 'trip_100p_1515_nov21', //100 Somersworth via 236
      'am': 'trip_100a_0520_nov21', //100 PNSY Gate 1 via 236
    },
  },

};